//  Custom cursor
document.addEventListener('DOMContentLoaded', function () {
  var cursor = document.getElementById('cursor');
  if (cursor) {
    document.addEventListener('mousemove', function (e) {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
    });
    document.querySelectorAll('button, a, [onclick], .product-card, .app-card, .nav-link').forEach(function (el) {
      el.addEventListener('mouseenter', function () { cursor.classList.add('expand'); });
      el.addEventListener('mouseleave', function () { cursor.classList.remove('expand'); });
    });
  }

  //  Mobile nav toggle
  window.toggleNav = function () {
    var links = document.getElementById('navLinks');
    var toggle = document.getElementById('navToggle');
    var isOpen = links.classList.toggle('open');
    toggle.classList.toggle('open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  };
  window.closeNav = function () {
    var links = document.getElementById('navLinks');
    var toggle = document.getElementById('navToggle');
    if (links) links.classList.remove('open');
    if (toggle) { toggle.classList.remove('open'); toggle.setAttribute('aria-expanded', 'false'); }
  };

  //  Dissolve-in on scroll for the Applications overview section
  var overviewSection = document.querySelector('.app-overview-fade');
  if (overviewSection) {
    if (!('IntersectionObserver' in window)) {
      overviewSection.classList.add('is-visible');
    } else {
      var overviewObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            overviewSection.classList.add('is-visible');
            overviewObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -80px 0px' });
      overviewObserver.observe(overviewSection);
    }
  }
});

//  Quick-jump nav on Applications & Specs page (real in-page anchor scroll, unrelated to old SPA routing)
window.jumpToApp = function (e, id) {
  e.preventDefault();
  var el = document.getElementById(id);
  if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  return false;
};
